import React, { ReactElement } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Document, Page } from 'react-pdf';
import { useState } from 'react';
import { LiveProps } from '../../LiveContainer';
import pdfTerm from '../../../../assets/pdf/prohibited_item.pdf';
import './LiveGuideline.scss';

export const LiveGuideline = (props: LiveProps): ReactElement => {
  const [numPages, setNumPages] = useState(null);

  const handleClose = () => {
    props.toggleGuidelineModal(false);
    props.toggleSettingsModal(true);
  };

  const onDocumentLoadSuccess = (pdf: any) => {
    setNumPages(pdf.numPages);
  };

  return (
    <Modal
      show={props.liveState.isShowGuidelineModal}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      dialogClassName="live-guideline__modal-dialog"
      contentClassName="live-guideline__modal-content"
      scrollable={true}
    >
      <Modal.Header closeButton></Modal.Header>

      <Modal.Body>
        <Document
          file={pdfTerm}
          onLoadSuccess={onDocumentLoadSuccess}
          renderMode="canvas"
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              scale={1.8}
              renderTextLayer={false}
            />
          ))}
        </Document>
      </Modal.Body>

      <Modal.Footer style={{ justifyContent: 'center' }}>
        <div className="text-center">
          <Button variant="primary" onClick={handleClose}>
            閉じる
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
